export const timezones = [
    {
        value: "Dateline Standard Time",
        abbr: "DST",
        offset: -12,
        isdst: false,
        text: "(UTC-12:00) International Date Line West",
        utc: ["Etc/GMT+12"],
    },
    {
        value: "UTC-11",
        abbr: "U",
        offset: -11,
        isdst: false,
        text: "(UTC-11:00) Coordinated Universal Time-11",
        utc: ["Etc/GMT+11", "Pacific/Midway", "Pacific/Niue", "Pacific/Pago_Pago"],
    },
    {
        value: "Hawaiian Standard Time",
        abbr: "HST",
        offset: -10,
        isdst: false,
        text: "(UTC-10:00) Hawaii",
        utc: ["Etc/GMT+10", "Pacific/Honolulu", "Pacific/Johnston", "Pacific/Rarotonga", "Pacific/Tahiti"],
    },
    {
        value: "Alaskan Standard Time",
        abbr: "AKDT",
        offset: -8,
        isdst: true,
        text: "(UTC-09:00) Alaska",
        utc: ["America/Anchorage", "America/Juneau", "America/Nome", "America/Sitka", "America/Yakutat"],
    },
    {
        value: "Pacific Standard Time (Mexico)",
        abbr: "PDT",
        offset: -7,
        isdst: true,
        text: "(UTC-08:00) Baja California",
        utc: ["America/Santa_Isabel"],
    },
    {
        value: "Pacific Daylight Time",
        abbr: "PDT",
        offset: -7,
        isdst: true,
        text: "(UTC-07:00) Pacific Time (US & Canada)",
        utc: ["America/Los_Angeles", "America/Tijuana", "America/Vancouver"],
    },
    {
        value: "Pacific Standard Time",
        abbr: "PST",
        offset: -8,
        isdst: false,
        text: "(UTC-08:00) Pacific Time (US & Canada)",
        utc: ["America/Los_Angeles", "America/Tijuana", "America/Vancouver", "PST8PDT"],
    },
    {
        value: "US Mountain Standard Time",
        abbr: "UMST",
        offset: -7,
        isdst: false,
        text: "(UTC-07:00) Arizona",
        utc: ["America/Creston", "America/Dawson", "America/Dawson_Creek", "America/Hermosillo", "America/Phoenix", "America/Whitehorse", "Etc/GMT+7"],
    },
    {
        value: "Mountain Standard Time (Mexico)",
        abbr: "MDT",
        offset: -6,
        isdst: true,
        text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
        utc: ["America/Chihuahua", "America/Mazatlan"],
    },
    {
        value: "Mountain Standard Time",
        abbr: "MDT",
        offset: -6,
        isdst: true,
        text: "(UTC-07:00) Mountain Time (US & Canada)",
        utc: [
            "America/Boise",
            "America/Cambridge_Bay",
            "America/Denver",
            "America/Edmonton",
            "America/Inuvik",
            "America/Ojinaga",
            "America/Yellowknife",
            "MST7MDT",
        ],
    },
    {
        value: "Central America Standard Time",
        abbr: "CAST",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Central America",
        utc: [
            "America/Belize",
            "America/Costa_Rica",
            "America/El_Salvador",
            "America/Guatemala",
            "America/Managua",
            "America/Tegucigalpa",
            "Etc/GMT+6",
            "Pacific/Galapagos",
        ],
    },
    {
        value: "Central Standard Time",
        abbr: "CDT",
        offset: -5,
        isdst: true,
        text: "(UTC-06:00) Central Time (US & Canada)",
        utc: [
            "America/Chicago",
            "America/Indiana/Knox",
            "America/Indiana/Tell_City",
            "America/Matamoros",
            "America/Menominee",
            "America/North_Dakota/Beulah",
            "America/North_Dakota/Center",
            "America/North_Dakota/New_Salem",
            "America/Rainy_River",
            "America/Rankin_Inlet",
            "America/Resolute",
            "America/Winnipeg",
            "CST6CDT",
        ],
    },
    {
        value: "Central Standard Time (Mexico)",
        abbr: "CDT",
        offset: -5,
        isdst: true,
        text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
        utc: ["America/Bahia_Banderas", "America/Cancun", "America/Merida", "America/Mexico_City", "America/Monterrey"],
    },
    {
        value: "Canada Central Standard Time",
        abbr: "CCST",
        offset: -6,
        isdst: false,
        text: "(UTC-06:00) Saskatchewan",
        utc: ["America/Regina", "America/Swift_Current"],
    },
    {
        value: "SA Pacific Standard Time",
        abbr: "SPST",
        offset: -5,
        isdst: false,
        text: "(UTC-05:00) Bogota, Lima, Quito",
        utc: [
            "America/Bogota",
            "America/Cayman",
            "America/Coral_Harbour",
            "America/Eirunepe",
            "America/Guayaquil",
            "America/Jamaica",
            "America/Lima",
            "America/Panama",
            "America/Rio_Branco",
            "Etc/GMT+5",
        ],
    },
    {
        value: "Eastern Standard Time",
        abbr: "EST",
        offset: -5,
        isdst: false,
        text: "(UTC-05:00) Eastern Time (US & Canada)",
        utc: [
            "America/Detroit",
            "America/Havana",
            "America/Indiana/Petersburg",
            "America/Indiana/Vincennes",
            "America/Indiana/Winamac",
            "America/Iqaluit",
            "America/Kentucky/Monticello",
            "America/Louisville",
            "America/Montreal",
            "America/Nassau",
            "America/New_York",
            "America/Nipigon",
            "America/Pangnirtung",
            "America/Port-au-Prince",
            "America/Thunder_Bay",
            "America/Toronto",
        ],
    },
    {
        value: "Eastern Daylight Time",
        abbr: "EDT",
        offset: -4,
        isdst: true,
        text: "(UTC-04:00) Eastern Daylight Time (US & Canada)",
        utc: [
            "America/Detroit",
            "America/Havana",
            "America/Indiana/Petersburg",
            "America/Indiana/Vincennes",
            "America/Indiana/Winamac",
            "America/Iqaluit",
            "America/Kentucky/Monticello",
            "America/Louisville",
            "America/Montreal",
            "America/Nassau",
            "America/New_York",
            "America/Nipigon",
            "America/Pangnirtung",
            "America/Port-au-Prince",
            "America/Thunder_Bay",
            "America/Toronto",
        ],
    },
    {
        value: "US Eastern Standard Time",
        abbr: "UEDT",
        offset: -5,
        isdst: false,
        text: "(UTC-05:00) Indiana (East)",
        utc: ["America/Indiana/Marengo", "America/Indiana/Vevay", "America/Indianapolis"],
    },
    {
        value: "Venezuela Standard Time",
        abbr: "VST",
        offset: -4.5,
        isdst: false,
        text: "(UTC-04:30) Caracas",
        utc: ["America/Caracas"],
    },
    {
        value: "Paraguay Standard Time",
        abbr: "PYT",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Asuncion",
        utc: ["America/Asuncion"],
    },
    {
        value: "Atlantic Standard Time",
        abbr: "ADT",
        offset: -3,
        isdst: true,
        text: "(UTC-04:00) Atlantic Time (Canada)",
        utc: ["America/Glace_Bay", "America/Goose_Bay", "America/Halifax", "America/Moncton", "America/Thule", "Atlantic/Bermuda"],
    },
    {
        value: "Central Brazilian Standard Time",
        abbr: "CBST",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Cuiaba",
        utc: ["America/Campo_Grande", "America/Cuiaba"],
    },
    {
        value: "SA Western Standard Time",
        abbr: "SWST",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
        utc: [
            "America/Anguilla",
            "America/Antigua",
            "America/Aruba",
            "America/Barbados",
            "America/Blanc-Sablon",
            "America/Boa_Vista",
            "America/Curacao",
            "America/Dominica",
            "America/Grand_Turk",
            "America/Grenada",
            "America/Guadeloupe",
            "America/Guyana",
            "America/Kralendijk",
            "America/La_Paz",
            "America/Lower_Princes",
            "America/Manaus",
            "America/Marigot",
            "America/Martinique",
            "America/Montserrat",
            "America/Port_of_Spain",
            "America/Porto_Velho",
            "America/Puerto_Rico",
            "America/Santo_Domingo",
            "America/St_Barthelemy",
            "America/St_Kitts",
            "America/St_Lucia",
            "America/St_Thomas",
            "America/St_Vincent",
            "America/Tortola",
            "Etc/GMT+4",
        ],
    },
    {
        value: "Pacific SA Standard Time",
        abbr: "PSST",
        offset: -4,
        isdst: false,
        text: "(UTC-04:00) Santiago",
        utc: ["America/Santiago", "Antarctica/Palmer"],
    },
    {
        value: "Newfoundland Standard Time",
        abbr: "NDT",
        offset: -2.5,
        isdst: true,
        text: "(UTC-03:30) Newfoundland",
        utc: ["America/St_Johns"],
    },
    {
        value: "E. South America Standard Time",
        abbr: "ESAST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Brasilia",
        utc: ["America/Sao_Paulo"],
    },
    {
        value: "Argentina Standard Time",
        abbr: "AST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Buenos Aires",
        utc: [
            "America/Argentina/La_Rioja",
            "America/Argentina/Rio_Gallegos",
            "America/Argentina/Salta",
            "America/Argentina/San_Juan",
            "America/Argentina/San_Luis",
            "America/Argentina/Tucuman",
            "America/Argentina/Ushuaia",
            "America/Buenos_Aires",
            "America/Catamarca",
            "America/Cordoba",
            "America/Jujuy",
            "America/Mendoza",
        ],
    },
    {
        value: "SA Eastern Standard Time",
        abbr: "SEST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Cayenne, Fortaleza",
        utc: [
            "America/Araguaina",
            "America/Belem",
            "America/Cayenne",
            "America/Fortaleza",
            "America/Maceio",
            "America/Paramaribo",
            "America/Recife",
            "America/Santarem",
            "Antarctica/Rothera",
            "Atlantic/Stanley",
            "Etc/GMT+3",
        ],
    },
    {
        value: "Greenland Standard Time",
        abbr: "GDT",
        offset: -3,
        isdst: true,
        text: "(UTC-03:00) Greenland",
        utc: ["America/Godthab"],
    },
    {
        value: "Montevideo Standard Time",
        abbr: "MST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Montevideo",
        utc: ["America/Montevideo"],
    },
    {
        value: "Bahia Standard Time",
        abbr: "BST",
        offset: -3,
        isdst: false,
        text: "(UTC-03:00) Salvador",
        utc: ["America/Bahia"],
    },
    {
        value: "UTC-02",
        abbr: "U",
        offset: -2,
        isdst: false,
        text: "(UTC-02:00) Coordinated Universal Time-02",
        utc: ["America/Noronha", "Atlantic/South_Georgia", "Etc/GMT+2"],
    },
    {
        value: "Mid-Atlantic Standard Time",
        abbr: "MDT",
        offset: -1,
        isdst: true,
        text: "(UTC-02:00) Mid-Atlantic - Old",
        utc: [],
    },
    {
        value: "Azores Standard Time",
        abbr: "ADT",
        offset: 0,
        isdst: true,
        text: "(UTC-01:00) Azores",
        utc: ["America/Scoresbysund", "Atlantic/Azores"],
    },
    {
        value: "Cape Verde Standard Time",
        abbr: "CVST",
        offset: -1,
        isdst: false,
        text: "(UTC-01:00) Cape Verde Is.",
        utc: ["Atlantic/Cape_Verde", "Etc/GMT+1"],
    },
    {
        value: "Morocco Standard Time",
        abbr: "MDT",
        offset: 1,
        isdst: true,
        text: "(UTC) Casablanca",
        utc: ["Africa/Casablanca", "Africa/El_Aaiun"],
    },
    {
        value: "UTC",
        abbr: "UTC",
        offset: 0,
        isdst: false,
        text: "(UTC) Coordinated Universal Time",
        utc: ["America/Danmarkshavn", "Etc/GMT"],
    },
    {
        value: "GMT Standard Time",
        abbr: "GMT",
        offset: 0,
        isdst: false,
        text: "(UTC) Edinburgh, London",
        utc: ["Europe/Isle_of_Man", "Europe/Guernsey", "Europe/Jersey", "Europe/London"],
    },
    {
        value: "British Summer Time",
        abbr: "BST",
        offset: 1,
        isdst: true,
        text: "(UTC+01:00) Edinburgh, London",
        utc: ["Europe/Isle_of_Man", "Europe/Guernsey", "Europe/Jersey", "Europe/London"],
    },
    {
        value: "GMT Standard Time",
        abbr: "GDT",
        offset: 1,
        isdst: true,
        text: "(UTC) Dublin, Lisbon",
        utc: ["Atlantic/Canary", "Atlantic/Faeroe", "Atlantic/Madeira", "Europe/Dublin", "Europe/Lisbon"],
    },
    {
        value: "Greenwich Standard Time",
        abbr: "GST",
        offset: 0,
        isdst: false,
        text: "(UTC) Monrovia, Reykjavik",
        utc: [
            "Africa/Abidjan",
            "Africa/Accra",
            "Africa/Bamako",
            "Africa/Banjul",
            "Africa/Bissau",
            "Africa/Conakry",
            "Africa/Dakar",
            "Africa/Freetown",
            "Africa/Lome",
            "Africa/Monrovia",
            "Africa/Nouakchott",
            "Africa/Ouagadougou",
            "Africa/Sao_Tome",
            "Atlantic/Reykjavik",
            "Atlantic/St_Helena",
        ],
    },
    {
        value: "W. Europe Standard Time",
        abbr: "WEDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
        utc: [
            "Arctic/Longyearbyen",
            "Europe/Amsterdam",
            "Europe/Andorra",
            "Europe/Berlin",
            "Europe/Busingen",
            "Europe/Gibraltar",
            "Europe/Luxembourg",
            "Europe/Malta",
            "Europe/Monaco",
            "Europe/Oslo",
            "Europe/Rome",
            "Europe/San_Marino",
            "Europe/Stockholm",
            "Europe/Vaduz",
            "Europe/Vatican",
            "Europe/Vienna",
            "Europe/Zurich",
        ],
    },
    {
        value: "Central Europe Standard Time",
        abbr: "CEDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
        utc: ["Europe/Belgrade", "Europe/Bratislava", "Europe/Budapest", "Europe/Ljubljana", "Europe/Podgorica", "Europe/Prague", "Europe/Tirane"],
    },
    {
        value: "Romance Standard Time",
        abbr: "RDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
        utc: ["Africa/Ceuta", "Europe/Brussels", "Europe/Copenhagen", "Europe/Madrid", "Europe/Paris"],
    },
    {
        value: "Central European Standard Time",
        abbr: "CEDT",
        offset: 2,
        isdst: true,
        text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
        utc: ["Europe/Sarajevo", "Europe/Skopje", "Europe/Warsaw", "Europe/Zagreb"],
    },
    {
        value: "W. Central Africa Standard Time",
        abbr: "WCAST",
        offset: 1,
        isdst: false,
        text: "(UTC+01:00) West Central Africa",
        utc: [
            "Africa/Algiers",
            "Africa/Bangui",
            "Africa/Brazzaville",
            "Africa/Douala",
            "Africa/Kinshasa",
            "Africa/Lagos",
            "Africa/Libreville",
            "Africa/Luanda",
            "Africa/Malabo",
            "Africa/Ndjamena",
            "Africa/Niamey",
            "Africa/Porto-Novo",
            "Africa/Tunis",
            "Etc/GMT-1",
        ],
    },
    {
        value: "Namibia Standard Time",
        abbr: "NST",
        offset: 1,
        isdst: false,
        text: "(UTC+01:00) Windhoek",
        utc: ["Africa/Windhoek"],
    },
    {
        value: "GTB Standard Time",
        abbr: "GDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Athens, Bucharest",
        utc: ["Asia/Nicosia", "Europe/Athens", "Europe/Bucharest", "Europe/Chisinau"],
    },
    {
        value: "Middle East Standard Time",
        abbr: "MEDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Beirut",
        utc: ["Asia/Beirut"],
    },
    {
        value: "Egypt Standard Time",
        abbr: "EST",
        offset: 2,
        isdst: false,
        text: "(UTC+02:00) Cairo",
        utc: ["Africa/Cairo"],
    },
    {
        value: "Syria Standard Time",
        abbr: "SDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Damascus",
        utc: ["Asia/Damascus"],
    },
    {
        value: "E. Europe Standard Time",
        abbr: "EEDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) E. Europe",
        utc: [
            "Asia/Nicosia",
            "Europe/Athens",
            "Europe/Bucharest",
            "Europe/Chisinau",
            "Europe/Helsinki",
            "Europe/Kiev",
            "Europe/Mariehamn",
            "Europe/Nicosia",
            "Europe/Riga",
            "Europe/Sofia",
            "Europe/Tallinn",
            "Europe/Uzhgorod",
            "Europe/Vilnius",
            "Europe/Zaporozhye",
        ],
    },
    {
        value: "South Africa Standard Time",
        abbr: "SAST",
        offset: 2,
        isdst: false,
        text: "(UTC+02:00) Harare, Pretoria",
        utc: [
            "Africa/Blantyre",
            "Africa/Bujumbura",
            "Africa/Gaborone",
            "Africa/Harare",
            "Africa/Johannesburg",
            "Africa/Kigali",
            "Africa/Lubumbashi",
            "Africa/Lusaka",
            "Africa/Maputo",
            "Africa/Maseru",
            "Africa/Mbabane",
            "Etc/GMT-2",
        ],
    },
    {
        value: "FLE Standard Time",
        abbr: "FDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
        utc: [
            "Europe/Helsinki",
            "Europe/Kiev",
            "Europe/Mariehamn",
            "Europe/Riga",
            "Europe/Sofia",
            "Europe/Tallinn",
            "Europe/Uzhgorod",
            "Europe/Vilnius",
            "Europe/Zaporozhye",
        ],
    },
    {
        value: "Turkey Standard Time",
        abbr: "TDT",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Istanbul",
        utc: ["Europe/Istanbul"],
    },
    {
        value: "Israel Standard Time",
        abbr: "JDT",
        offset: 3,
        isdst: true,
        text: "(UTC+02:00) Jerusalem",
        utc: ["Asia/Jerusalem"],
    },
    {
        value: "Libya Standard Time",
        abbr: "LST",
        offset: 2,
        isdst: false,
        text: "(UTC+02:00) Tripoli",
        utc: ["Africa/Tripoli"],
    },
    {
        value: "Jordan Standard Time",
        abbr: "JST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Amman",
        utc: ["Asia/Amman"],
    },
    {
        value: "Arabic Standard Time",
        abbr: "AST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Baghdad",
        utc: ["Asia/Baghdad"],
    },
    {
        value: "Kaliningrad Standard Time",
        abbr: "KST",
        offset: 3,
        isdst: false,
        text: "(UTC+02:00) Kaliningrad",
        utc: ["Europe/Kaliningrad"],
    },
    {
        value: "Arab Standard Time",
        abbr: "AST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Kuwait, Riyadh",
        utc: ["Asia/Aden", "Asia/Bahrain", "Asia/Kuwait", "Asia/Qatar", "Asia/Riyadh"],
    },
    {
        value: "E. Africa Standard Time",
        abbr: "EAST",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Nairobi",
        utc: [
            "Africa/Addis_Ababa",
            "Africa/Asmera",
            "Africa/Dar_es_Salaam",
            "Africa/Djibouti",
            "Africa/Juba",
            "Africa/Kampala",
            "Africa/Khartoum",
            "Africa/Mogadishu",
            "Africa/Nairobi",
            "Antarctica/Syowa",
            "Etc/GMT-3",
            "Indian/Antananarivo",
            "Indian/Comoro",
            "Indian/Mayotte",
        ],
    },
    {
        value: "Moscow Standard Time",
        abbr: "MSK",
        offset: 3,
        isdst: false,
        text: "(UTC+03:00) Moscow, St. Petersburg, Volgograd, Minsk",
        utc: ["Europe/Kirov", "Europe/Moscow", "Europe/Simferopol", "Europe/Volgograd", "Europe/Minsk"],
    },
    {
        value: "Samara Time",
        abbr: "SAMT",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Samara, Ulyanovsk, Saratov",
        utc: ["Europe/Astrakhan", "Europe/Samara", "Europe/Ulyanovsk"],
    },
    {
        value: "Iran Standard Time",
        abbr: "IDT",
        offset: 4.5,
        isdst: true,
        text: "(UTC+03:30) Tehran",
        utc: ["Asia/Tehran"],
    },
    {
        value: "Arabian Standard Time",
        abbr: "AST",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Abu Dhabi, Muscat",
        utc: ["Asia/Dubai", "Asia/Muscat", "Etc/GMT-4"],
    },
    {
        value: "Azerbaijan Standard Time",
        abbr: "ADT",
        offset: 5,
        isdst: true,
        text: "(UTC+04:00) Baku",
        utc: ["Asia/Baku"],
    },
    {
        value: "Mauritius Standard Time",
        abbr: "MST",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Port Louis",
        utc: ["Indian/Mahe", "Indian/Mauritius", "Indian/Reunion"],
    },
    {
        value: "Georgian Standard Time",
        abbr: "GET",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Tbilisi",
        utc: ["Asia/Tbilisi"],
    },
    {
        value: "Caucasus Standard Time",
        abbr: "CST",
        offset: 4,
        isdst: false,
        text: "(UTC+04:00) Yerevan",
        utc: ["Asia/Yerevan"],
    },
    {
        value: "Afghanistan Standard Time",
        abbr: "AST",
        offset: 4.5,
        isdst: false,
        text: "(UTC+04:30) Kabul",
        utc: ["Asia/Kabul"],
    },
    {
        value: "West Asia Standard Time",
        abbr: "WAST",
        offset: 5,
        isdst: false,
        text: "(UTC+05:00) Ashgabat, Tashkent",
        utc: [
            "Antarctica/Mawson",
            "Asia/Aqtau",
            "Asia/Aqtobe",
            "Asia/Ashgabat",
            "Asia/Dushanbe",
            "Asia/Oral",
            "Asia/Samarkand",
            "Asia/Tashkent",
            "Etc/GMT-5",
            "Indian/Kerguelen",
            "Indian/Maldives",
        ],
    },
    {
        value: "Yekaterinburg Time",
        abbr: "YEKT",
        offset: 5,
        isdst: false,
        text: "(UTC+05:00) Yekaterinburg",
        utc: ["Asia/Yekaterinburg"],
    },
    {
        value: "Pakistan Standard Time",
        abbr: "PKT",
        offset: 5,
        isdst: false,
        text: "(UTC+05:00) Islamabad, Karachi",
        utc: ["Asia/Karachi"],
    },
    {
        value: "India Standard Time",
        abbr: "IST",
        offset: 5.5,
        isdst: false,
        text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
        utc: ["Asia/Kolkata", "Asia/Calcutta"],
    },
    {
        value: "Sri Lanka Standard Time",
        abbr: "SLST",
        offset: 5.5,
        isdst: false,
        text: "(UTC+05:30) Sri Jayawardenepura",
        utc: ["Asia/Colombo"],
    },
    {
        value: "Nepal Standard Time",
        abbr: "NST",
        offset: 5.75,
        isdst: false,
        text: "(UTC+05:45) Kathmandu",
        utc: ["Asia/Kathmandu"],
    },
    {
        value: "Central Asia Standard Time",
        abbr: "CAST",
        offset: 6,
        isdst: false,
        text: "(UTC+06:00) Nur-Sultan (Astana)",
        utc: ["Antarctica/Vostok", "Asia/Almaty", "Asia/Bishkek", "Asia/Qyzylorda", "Asia/Urumqi", "Etc/GMT-6", "Indian/Chagos"],
    },
    {
        value: "Bangladesh Standard Time",
        abbr: "BST",
        offset: 6,
        isdst: false,
        text: "(UTC+06:00) Dhaka",
        utc: ["Asia/Dhaka", "Asia/Thimphu"],
    },
    {
        value: "Myanmar Standard Time",
        abbr: "MST",
        offset: 6.5,
        isdst: false,
        text: "(UTC+06:30) Yangon (Rangoon)",
        utc: ["Asia/Rangoon", "Indian/Cocos"],
    },
    {
        value: "SE Asia Standard Time",
        abbr: "SAST",
        offset: 7,
        isdst: false,
        text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
        utc: [
            "Antarctica/Davis",
            "Asia/Bangkok",
            "Asia/Hovd",
            "Asia/Jakarta",
            "Asia/Phnom_Penh",
            "Asia/Pontianak",
            "Asia/Saigon",
            "Asia/Vientiane",
            "Etc/GMT-7",
            "Indian/Christmas",
        ],
    },
    {
        value: "N. Central Asia Standard Time",
        abbr: "NCAST",
        offset: 7,
        isdst: false,
        text: "(UTC+07:00) Novosibirsk",
        utc: ["Asia/Novokuznetsk", "Asia/Novosibirsk", "Asia/Omsk"],
    },
    {
        value: "China Standard Time",
        abbr: "CST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
        utc: ["Asia/Hong_Kong", "Asia/Macau", "Asia/Shanghai"],
    },
    {
        value: "North Asia Standard Time",
        abbr: "NAST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Krasnoyarsk",
        utc: ["Asia/Krasnoyarsk"],
    },
    {
        value: "Singapore Standard Time",
        abbr: "MPST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Kuala Lumpur, Singapore",
        utc: ["Asia/Brunei", "Asia/Kuala_Lumpur", "Asia/Kuching", "Asia/Makassar", "Asia/Manila", "Asia/Singapore", "Etc/GMT-8"],
    },
    {
        value: "W. Australia Standard Time",
        abbr: "WAST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Perth",
        utc: ["Antarctica/Casey", "Australia/Perth"],
    },
    {
        value: "Taipei Standard Time",
        abbr: "TST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Taipei",
        utc: ["Asia/Taipei"],
    },
    {
        value: "Ulaanbaatar Standard Time",
        abbr: "UST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Ulaanbaatar",
        utc: ["Asia/Choibalsan", "Asia/Ulaanbaatar"],
    },
    {
        value: "North Asia East Standard Time",
        abbr: "NAEST",
        offset: 8,
        isdst: false,
        text: "(UTC+08:00) Irkutsk",
        utc: ["Asia/Irkutsk"],
    },
    {
        value: "Japan Standard Time",
        abbr: "JST",
        offset: 9,
        isdst: false,
        text: "(UTC+09:00) Osaka, Sapporo, Tokyo",
        utc: ["Asia/Dili", "Asia/Jayapura", "Asia/Tokyo", "Etc/GMT-9", "Pacific/Palau"],
    },
    {
        value: "Korea Standard Time",
        abbr: "KST",
        offset: 9,
        isdst: false,
        text: "(UTC+09:00) Seoul",
        utc: ["Asia/Pyongyang", "Asia/Seoul"],
    },
    {
        value: "Cen. Australia Standard Time",
        abbr: "CAST",
        offset: 9.5,
        isdst: false,
        text: "(UTC+09:30) Adelaide",
        utc: ["Australia/Adelaide", "Australia/Broken_Hill"],
    },
    {
        value: "AUS Central Standard Time",
        abbr: "ACST",
        offset: 9.5,
        isdst: false,
        text: "(UTC+09:30) Darwin",
        utc: ["Australia/Darwin"],
    },
    {
        value: "E. Australia Standard Time",
        abbr: "EAST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Brisbane",
        utc: ["Australia/Brisbane", "Australia/Lindeman"],
    },
    {
        value: "AUS Eastern Standard Time",
        abbr: "AEST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Canberra, Melbourne, Sydney",
        utc: ["Australia/Melbourne", "Australia/Sydney"],
    },
    {
        value: "West Pacific Standard Time",
        abbr: "WPST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Guam, Port Moresby",
        utc: ["Antarctica/DumontDUrville", "Etc/GMT-10", "Pacific/Guam", "Pacific/Port_Moresby", "Pacific/Saipan", "Pacific/Truk"],
    },
    {
        value: "Tasmania Standard Time",
        abbr: "TST",
        offset: 10,
        isdst: false,
        text: "(UTC+10:00) Hobart",
        utc: ["Australia/Currie", "Australia/Hobart"],
    },
    {
        value: "Yakutsk Standard Time",
        abbr: "YST",
        offset: 9,
        isdst: false,
        text: "(UTC+09:00) Yakutsk",
        utc: ["Asia/Chita", "Asia/Khandyga", "Asia/Yakutsk"],
    },
    {
        value: "Central Pacific Standard Time",
        abbr: "CPST",
        offset: 11,
        isdst: false,
        text: "(UTC+11:00) Solomon Is., New Caledonia",
        utc: ["Antarctica/Macquarie", "Etc/GMT-11", "Pacific/Efate", "Pacific/Guadalcanal", "Pacific/Kosrae", "Pacific/Noumea", "Pacific/Ponape"],
    },
    {
        value: "Vladivostok Standard Time",
        abbr: "VST",
        offset: 11,
        isdst: false,
        text: "(UTC+11:00) Vladivostok",
        utc: ["Asia/Sakhalin", "Asia/Ust-Nera", "Asia/Vladivostok"],
    },
    {
        value: "New Zealand Standard Time",
        abbr: "NZST",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Auckland, Wellington",
        utc: ["Antarctica/McMurdo", "Pacific/Auckland"],
    },
    {
        value: "UTC+12",
        abbr: "U",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Coordinated Universal Time+12",
        utc: ["Etc/GMT-12", "Pacific/Funafuti", "Pacific/Kwajalein", "Pacific/Majuro", "Pacific/Nauru", "Pacific/Tarawa", "Pacific/Wake", "Pacific/Wallis"],
    },
    {
        value: "Fiji Standard Time",
        abbr: "FST",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Fiji",
        utc: ["Pacific/Fiji"],
    },
    {
        value: "Magadan Standard Time",
        abbr: "MST",
        offset: 12,
        isdst: false,
        text: "(UTC+12:00) Magadan",
        utc: ["Asia/Anadyr", "Asia/Kamchatka", "Asia/Magadan", "Asia/Srednekolymsk"],
    },
    {
        value: "Kamchatka Standard Time",
        abbr: "KDT",
        offset: 13,
        isdst: true,
        text: "(UTC+12:00) Petropavlovsk-Kamchatsky - Old",
        utc: ["Asia/Kamchatka"],
    },
    {
        value: "Tonga Standard Time",
        abbr: "TST",
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Nuku'alofa",
        utc: ["Etc/GMT-13", "Pacific/Enderbury", "Pacific/Fakaofo", "Pacific/Tongatapu"],
    },
    {
        value: "Samoa Standard Time",
        abbr: "SST",
        offset: 13,
        isdst: false,
        text: "(UTC+13:00) Samoa",
        utc: ["Pacific/Apia"],
    },
];

export const timezoneArr = [
    { name: "Pacific/Niue", offset: -11, country: "Niue", countryCode: "NU" },
    { name: "Pacific/Midway", offset: -11, country: "United States Minor Outlying Islands", countryCode: "UM" },
    { name: "Pacific/Pago_Pago", offset: -11, country: "American Samoa", countryCode: "AS" },
    { name: "Pacific/Rarotonga", offset: -10, country: "Cook Islands", countryCode: "CK" },
    { name: "America/Adak", offset: -10, country: "United States", countryCode: "US" },
    { name: "Pacific/Honolulu", offset: -10, country: "United States", countryCode: "US" },
    { name: "Pacific/Tahiti", offset: -10, country: "French Polynesia", countryCode: "PF" },
    { name: "Pacific/Marquesas", offset: -9.5, country: "French Polynesia", countryCode: "PF" },
    { name: "America/Anchorage", offset: -9, country: "United States", countryCode: "US" },
    { name: "Pacific/Gambier", offset: -9, country: "French Polynesia", countryCode: "PF" },
    { name: "America/Los_Angeles", offset: -8, country: "United States", countryCode: "US" },
    { name: "America/Tijuana", offset: -8, country: "Mexico", countryCode: "MX" },
    { name: "America/Vancouver", offset: -8, country: "Canada", countryCode: "CA" },
    { name: "Pacific/Pitcairn", offset: -8, country: "Pitcairn", countryCode: "PN" },
    { name: "America/Hermosillo", offset: -7, country: "Mexico", countryCode: "MX" },
    { name: "America/Edmonton", offset: -7, country: "Canada", countryCode: "CA" },
    { name: "America/Ojinaga", offset: -7, country: "Mexico", countryCode: "MX" },
    { name: "America/Denver", offset: -7, country: "United States", countryCode: "US" },
    { name: "America/Phoenix", offset: -7, country: "United States", countryCode: "US" },
    { name: "America/Whitehorse", offset: -7, country: "Canada", countryCode: "CA" },
    { name: "America/Belize", offset: -6, country: "Belize", countryCode: "BZ" },
    { name: "America/Chicago", offset: -6, country: "United States", countryCode: "US" },
    { name: "America/Guatemala", offset: -6, country: "Guatemala", countryCode: "GT" },
    { name: "America/Managua", offset: -6, country: "Nicaragua", countryCode: "NI" },
    { name: "America/Mexico_City", offset: -6, country: "Mexico", countryCode: "MX" },
    { name: "America/Costa_Rica", offset: -6, country: "Costa Rica", countryCode: "CR" },
    { name: "America/El_Salvador", offset: -6, country: "El Salvador", countryCode: "SV" },
    { name: "America/Regina", offset: -6, country: "Canada", countryCode: "CA" },
    { name: "America/Tegucigalpa", offset: -6, country: "Honduras", countryCode: "HN" },
    { name: "America/Winnipeg", offset: -6, country: "Canada", countryCode: "CA" },
    { name: "Pacific/Easter", offset: -6, country: "Chile", countryCode: "CL" },
    { name: "Pacific/Galapagos", offset: -6, country: "Ecuador", countryCode: "EC" },
    { name: "America/Rio_Branco", offset: -5, country: "Brazil", countryCode: "BR" },
    { name: "America/Bogota", offset: -5, country: "Colombia", countryCode: "CO" },
    { name: "America/Havana", offset: -5, country: "Cuba", countryCode: "CU" },
    { name: "America/Atikokan", offset: -5, country: "Canada", countryCode: "CA" },
    { name: "America/Cancun", offset: -5, country: "Mexico", countryCode: "MX" },
    { name: "America/Grand_Turk", offset: -5, country: "Turks and Caicos Islands", countryCode: "TC" },
    { name: "America/Cayman", offset: -5, country: "Cayman Islands", countryCode: "KY" },
    { name: "America/Jamaica", offset: -5, country: "Jamaica", countryCode: "JM" },
    { name: "America/Nassau", offset: -5, country: "Bahamas", countryCode: "BS" },
    { name: "America/New_York", offset: -5, country: "United States", countryCode: "US" },
    { name: "America/Panama", offset: -5, country: "Panama", countryCode: "PA" },
    { name: "America/Port-au-Prince", offset: -5, country: "Haiti", countryCode: "HT" },
    { name: "America/Toronto", offset: -5, country: "Canada", countryCode: "CA" },
    { name: "America/Guayaquil", offset: -5, country: "Ecuador", countryCode: "EC" },
    { name: "America/Lima", offset: -5, country: "Peru", countryCode: "PE" },
    { name: "America/Manaus", offset: -4, country: "Brazil", countryCode: "BR" },
    { name: "America/St_Kitts", offset: -4, country: "Saint Kitts and Nevis", countryCode: "KN" },
    { name: "America/Blanc-Sablon", offset: -4, country: "Canada", countryCode: "CA" },
    { name: "America/Montserrat", offset: -4, country: "Montserrat", countryCode: "MS" },
    { name: "America/Barbados", offset: -4, country: "Barbados", countryCode: "BB" },
    { name: "America/St_Lucia", offset: -4, country: "Saint Lucia", countryCode: "LC" },
    { name: "America/Port_of_Spain", offset: -4, country: "Trinidad and Tobago", countryCode: "TT" },
    { name: "America/Martinique", offset: -4, country: "Martinique", countryCode: "MQ" },
    { name: "America/St_Barthelemy", offset: -4, country: "Saint Barthelemy", countryCode: "BL" },
    { name: "America/Halifax", offset: -4, country: "Canada", countryCode: "CA" },
    { name: "Atlantic/Bermuda", offset: -4, country: "Bermuda", countryCode: "BM" },
    { name: "America/St_Vincent", offset: -4, country: "Saint Vincent and the Grenadines", countryCode: "VC" },
    { name: "America/Kralendijk", offset: -4, country: "Bonaire, Saint Eustatius and Saba ", countryCode: "BQ" },
    { name: "America/Guadeloupe", offset: -4, country: "Guadeloupe", countryCode: "GP" },
    { name: "America/Marigot", offset: -4, country: "Saint Martin", countryCode: "MF" },
    { name: "America/Aruba", offset: -4, country: "Aruba", countryCode: "AW" },
    { name: "America/Lower_Princes", offset: -4, country: "Sint Maarten", countryCode: "SX" },
    { name: "America/Tortola", offset: -4, country: "British Virgin Islands", countryCode: "VG" },
    { name: "America/Dominica", offset: -4, country: "Dominica", countryCode: "DM" },
    { name: "America/St_Thomas", offset: -4, country: "U.S. Virgin Islands", countryCode: "VI" },
    { name: "America/Grenada", offset: -4, country: "Grenada", countryCode: "GD" },
    { name: "America/Antigua", offset: -4, country: "Antigua and Barbuda", countryCode: "AG" },
    { name: "America/Puerto_Rico", offset: -4, country: "Puerto Rico", countryCode: "PR" },
    { name: "America/Santo_Domingo", offset: -4, country: "Dominican Republic", countryCode: "DO" },
    { name: "America/Anguilla", offset: -4, country: "Anguilla", countryCode: "AI" },
    { name: "America/Thule", offset: -4, country: "Greenland", countryCode: "GL" },
    { name: "America/Curacao", offset: -4, country: "Curacao", countryCode: "CW" },
    { name: "America/La_Paz", offset: -4, country: "Bolivia", countryCode: "BO" },
    { name: "America/Santiago", offset: -4, country: "Chile", countryCode: "CL" },
    { name: "America/Guyana", offset: -4, country: "Guyana", countryCode: "GY" },
    { name: "America/Asuncion", offset: -4, country: "Paraguay", countryCode: "PY" },
    { name: "America/Caracas", offset: -4, country: "Venezuela", countryCode: "VE" },
    { name: "America/St_Johns", offset: -3.5, country: "Canada", countryCode: "CA" },
    { name: "America/Argentina/Buenos_Aires", offset: -3, country: "Argentina", countryCode: "AR" },
    { name: "America/Sao_Paulo", offset: -3, country: "Brazil", countryCode: "BR" },
    { name: "Antarctica/Palmer", offset: -3, country: "Antarctica", countryCode: "AQ" },
    { name: "America/Punta_Arenas", offset: -3, country: "Chile", countryCode: "CL" },
    { name: "Atlantic/Stanley", offset: -3, country: "Falkland Islands", countryCode: "FK" },
    { name: "America/Cayenne", offset: -3, country: "French Guiana", countryCode: "GF" },
    { name: "America/Miquelon", offset: -3, country: "Saint Pierre and Miquelon", countryCode: "PM" },
    { name: "America/Paramaribo", offset: -3, country: "Suriname", countryCode: "SR" },
    { name: "America/Montevideo", offset: -3, country: "Uruguay", countryCode: "UY" },
    { name: "America/Nuuk", offset: -3, country: "Greenland", countryCode: "GL" },
    { name: "America/Noronha", offset: -2, country: "Brazil", countryCode: "BR" },
    { name: "Atlantic/South_Georgia", offset: -2, country: "South Georgia and the South Sandwich Islands", countryCode: "GS" },
    { name: "Atlantic/Azores", offset: -1, country: "Portugal", countryCode: "PT" },
    { name: "Atlantic/Cape_Verde", offset: -1, country: "Cabo Verde", countryCode: "CV" },
    { name: "America/Scoresbysund", offset: -1, country: "Greenland", countryCode: "GL" },
    { name: "Africa/Abidjan", offset: 0, country: "Ivory Coast", countryCode: "CI" },
    { name: "Africa/Accra", offset: 0, country: "Ghana", countryCode: "GH" },
    { name: "Africa/Bamako", offset: 0, country: "Mali", countryCode: "ML" },
    { name: "Africa/Bissau", offset: 0, country: "Guinea-Bissau", countryCode: "GW" },
    { name: "Africa/Conakry", offset: 0, country: "Guinea", countryCode: "GN" },
    { name: "Africa/Dakar", offset: 0, country: "Senegal", countryCode: "SN" },
    { name: "America/Danmarkshavn", offset: 0, country: "Greenland", countryCode: "GL" },
    { name: "Europe/Isle_of_Man", offset: 0, country: "Isle of Man", countryCode: "IM" },
    { name: "Europe/Dublin", offset: 0, country: "Ireland", countryCode: "IE" },
    { name: "Africa/Freetown", offset: 0, country: "Sierra Leone", countryCode: "SL" },
    { name: "Atlantic/St_Helena", offset: 0, country: "Saint Helena", countryCode: "SH" },
    { name: "Africa/Lome", offset: 0, country: "Togo", countryCode: "TG" },
    { name: "Europe/London", offset: 0, country: "United Kingdom", countryCode: "GB" },
    { name: "Africa/Monrovia", offset: 0, country: "Liberia", countryCode: "LR" },
    { name: "Africa/Nouakchott", offset: 0, country: "Mauritania", countryCode: "MR" },
    { name: "Africa/Ouagadougou", offset: 0, country: "Burkina Faso", countryCode: "BF" },
    { name: "Atlantic/Reykjavik", offset: 0, country: "Iceland", countryCode: "IS" },
    { name: "Europe/Jersey", offset: 0, country: "Jersey", countryCode: "JE" },
    { name: "Europe/Guernsey", offset: 0, country: "Guernsey", countryCode: "GG" },
    { name: "Africa/Banjul", offset: 0, country: "Gambia", countryCode: "GM" },
    { name: "Africa/Sao_Tome", offset: 0, country: "Sao Tome and Principe", countryCode: "ST" },
    { name: "Antarctica/Troll", offset: 0, country: "Antarctica", countryCode: "AQ" },
    { name: "Africa/Casablanca", offset: 0, country: "Morocco", countryCode: "MA" },
    { name: "Africa/El_Aaiun", offset: 0, country: "Western Sahara", countryCode: "EH" },
    { name: "Atlantic/Canary", offset: 0, country: "Spain", countryCode: "ES" },
    { name: "Europe/Lisbon", offset: 0, country: "Portugal", countryCode: "PT" },
    { name: "Atlantic/Faroe", offset: 0, country: "Faroe Islands", countryCode: "FO" },
    { name: "Africa/Windhoek", offset: 1, country: "Namibia", countryCode: "NA" },
    { name: "Africa/Algiers", offset: 1, country: "Algeria", countryCode: "DZ" },
    { name: "Europe/Amsterdam", offset: 1, country: "Netherlands", countryCode: "NL" },
    { name: "Europe/Andorra", offset: 1, country: "Andorra", countryCode: "AD" },
    { name: "Europe/Belgrade", offset: 1, country: "Serbia", countryCode: "RS" },
    { name: "Europe/Berlin", offset: 1, country: "Germany", countryCode: "DE" },
    { name: "Europe/Malta", offset: 1, country: "Malta", countryCode: "MT" },
    { name: "Europe/Bratislava", offset: 1, country: "Slovakia", countryCode: "SK" },
    { name: "Europe/Brussels", offset: 1, country: "Belgium", countryCode: "BE" },
    { name: "Europe/Budapest", offset: 1, country: "Hungary", countryCode: "HU" },
    { name: "Europe/Copenhagen", offset: 1, country: "Denmark", countryCode: "DK" },
    { name: "Europe/Gibraltar", offset: 1, country: "Gibraltar", countryCode: "GI" },
    { name: "Europe/Ljubljana", offset: 1, country: "Slovenia", countryCode: "SI" },
    { name: "Arctic/Longyearbyen", offset: 1, country: "Svalbard and Jan Mayen", countryCode: "SJ" },
    { name: "Europe/Luxembourg", offset: 1, country: "Luxembourg", countryCode: "LU" },
    { name: "Europe/Madrid", offset: 1, country: "Spain", countryCode: "ES" },
    { name: "Europe/Monaco", offset: 1, country: "Monaco", countryCode: "MC" },
    { name: "Europe/Oslo", offset: 1, country: "Norway", countryCode: "NO" },
    { name: "Europe/Paris", offset: 1, country: "France", countryCode: "FR" },
    { name: "Europe/Podgorica", offset: 1, country: "Montenegro", countryCode: "ME" },
    { name: "Europe/Prague", offset: 1, country: "Czechia", countryCode: "CZ" },
    { name: "Europe/Rome", offset: 1, country: "Italy", countryCode: "IT" },
    { name: "Europe/San_Marino", offset: 1, country: "San Marino", countryCode: "SM" },
    { name: "Europe/Sarajevo", offset: 1, country: "Bosnia and Herzegovina", countryCode: "BA" },
    { name: "Europe/Skopje", offset: 1, country: "North Macedonia", countryCode: "MK" },
    { name: "Europe/Stockholm", offset: 1, country: "Sweden", countryCode: "SE" },
    { name: "Europe/Tirane", offset: 1, country: "Albania", countryCode: "AL" },
    { name: "Africa/Tunis", offset: 1, country: "Tunisia", countryCode: "TN" },
    { name: "Europe/Vaduz", offset: 1, country: "Liechtenstein", countryCode: "LI" },
    { name: "Europe/Vatican", offset: 1, country: "Vatican", countryCode: "VA" },
    { name: "Europe/Vienna", offset: 1, country: "Austria", countryCode: "AT" },
    { name: "Europe/Warsaw", offset: 1, country: "Poland", countryCode: "PL" },
    { name: "Europe/Zagreb", offset: 1, country: "Croatia", countryCode: "HR" },
    { name: "Europe/Zurich", offset: 1, country: "Switzerland", countryCode: "CH" },
    { name: "Africa/Bangui", offset: 1, country: "Central African Republic", countryCode: "CF" },
    { name: "Africa/Malabo", offset: 1, country: "Equatorial Guinea", countryCode: "GQ" },
    { name: "Africa/Brazzaville", offset: 1, country: "Republic of the Congo", countryCode: "CG" },
    { name: "Africa/Porto-Novo", offset: 1, country: "Benin", countryCode: "BJ" },
    { name: "Africa/Douala", offset: 1, country: "Cameroon", countryCode: "CM" },
    { name: "Africa/Kinshasa", offset: 1, country: "Democratic Republic of the Congo", countryCode: "CD" },
    { name: "Africa/Lagos", offset: 1, country: "Nigeria", countryCode: "NG" },
    { name: "Africa/Libreville", offset: 1, country: "Gabon", countryCode: "GA" },
    { name: "Africa/Luanda", offset: 1, country: "Angola", countryCode: "AO" },
    { name: "Africa/Ndjamena", offset: 1, country: "Chad", countryCode: "TD" },
    { name: "Africa/Niamey", offset: 1, country: "Niger", countryCode: "NE" },
    { name: "Africa/Bujumbura", offset: 2, country: "Burundi", countryCode: "BI" },
    { name: "Africa/Gaborone", offset: 2, country: "Botswana", countryCode: "BW" },
    { name: "Africa/Harare", offset: 2, country: "Zimbabwe", countryCode: "ZW" },
    { name: "Africa/Juba", offset: 2, country: "South Sudan", countryCode: "SS" },
    { name: "Africa/Khartoum", offset: 2, country: "Sudan", countryCode: "SD" },
    { name: "Africa/Kigali", offset: 2, country: "Rwanda", countryCode: "RW" },
    { name: "Africa/Blantyre", offset: 2, country: "Malawi", countryCode: "MW" },
    { name: "Africa/Lubumbashi", offset: 2, country: "Democratic Republic of the Congo", countryCode: "CD" },
    { name: "Africa/Lusaka", offset: 2, country: "Zambia", countryCode: "ZM" },
    { name: "Africa/Maputo", offset: 2, country: "Mozambique", countryCode: "MZ" },
    { name: "Asia/Damascus", offset: 2, country: "Syria", countryCode: "SY" },
    { name: "Asia/Amman", offset: 2, country: "Jordan", countryCode: "JO" },
    { name: "Europe/Athens", offset: 2, country: "Greece", countryCode: "GR" },
    { name: "Asia/Beirut", offset: 2, country: "Lebanon", countryCode: "LB" },
    { name: "Europe/Bucharest", offset: 2, country: "Romania", countryCode: "RO" },
    { name: "Africa/Cairo", offset: 2, country: "Egypt", countryCode: "EG" },
    { name: "Europe/Chisinau", offset: 2, country: "Moldova", countryCode: "MD" },
    { name: "Asia/Hebron", offset: 2, country: "Palestinian Territory", countryCode: "PS" },
    { name: "Europe/Helsinki", offset: 2, country: "Finland", countryCode: "FI" },
    { name: "Europe/Kaliningrad", offset: 2, country: "Russia", countryCode: "RU" },
    { name: "Europe/Kiev", offset: 2, country: "Ukraine", countryCode: "UA" },
    { name: "Europe/Mariehamn", offset: 2, country: "Aland Islands", countryCode: "AX" },
    { name: "Asia/Nicosia", offset: 2, country: "Cyprus", countryCode: "CY" },
    { name: "Europe/Riga", offset: 2, country: "Latvia", countryCode: "LV" },
    { name: "Europe/Sofia", offset: 2, country: "Bulgaria", countryCode: "BG" },
    { name: "Europe/Tallinn", offset: 2, country: "Estonia", countryCode: "EE" },
    { name: "Africa/Tripoli", offset: 2, country: "Libya", countryCode: "LY" },
    { name: "Europe/Vilnius", offset: 2, country: "Lithuania", countryCode: "LT" },
    { name: "Asia/Jerusalem", offset: 2, country: "Israel", countryCode: "IL" },
    { name: "Africa/Johannesburg", offset: 2, country: "South Africa", countryCode: "ZA" },
    { name: "Africa/Mbabane", offset: 2, country: "Eswatini", countryCode: "SZ" },
    { name: "Africa/Maseru", offset: 2, country: "Lesotho", countryCode: "LS" },
    { name: "Asia/Kuwait", offset: 3, country: "Kuwait", countryCode: "KW" },
    { name: "Asia/Baghdad", offset: 3, country: "Iraq", countryCode: "IQ" },
    { name: "Asia/Qatar", offset: 3, country: "Qatar", countryCode: "QA" },
    { name: "Asia/Bahrain", offset: 3, country: "Bahrain", countryCode: "BH" },
    { name: "Asia/Riyadh", offset: 3, country: "Saudi Arabia", countryCode: "SA" },
    { name: "Asia/Aden", offset: 3, country: "Yemen", countryCode: "YE" },
    { name: "Africa/Addis_Ababa", offset: 3, country: "Ethiopia", countryCode: "ET" },
    { name: "Indian/Antananarivo", offset: 3, country: "Madagascar", countryCode: "MG" },
    { name: "Africa/Asmara", offset: 3, country: "Eritrea", countryCode: "ER" },
    { name: "Africa/Dar_es_Salaam", offset: 3, country: "Tanzania", countryCode: "TZ" },
    { name: "Africa/Djibouti", offset: 3, country: "Djibouti", countryCode: "DJ" },
    { name: "Africa/Kampala", offset: 3, country: "Uganda", countryCode: "UG" },
    { name: "Indian/Mayotte", offset: 3, country: "Mayotte", countryCode: "YT" },
    { name: "Africa/Mogadishu", offset: 3, country: "Somalia", countryCode: "SO" },
    { name: "Indian/Comoro", offset: 3, country: "Comoros", countryCode: "KM" },
    { name: "Africa/Nairobi", offset: 3, country: "Kenya", countryCode: "KE" },
    { name: "Europe/Minsk", offset: 3, country: "Belarus", countryCode: "BY" },
    { name: "Europe/Moscow", offset: 3, country: "Russia", countryCode: "RU" },
    { name: "Europe/Simferopol", offset: 3, country: "Ukraine", countryCode: "UA" },
    { name: "Antarctica/Syowa", offset: 3, country: "Antarctica", countryCode: "AQ" },
    { name: "Europe/Istanbul", offset: 3, country: "Turkey", countryCode: "TR" },
    { name: "Asia/Tehran", offset: 3.5, country: "Iran", countryCode: "IR" },
    { name: "Asia/Yerevan", offset: 4, country: "Armenia", countryCode: "AM" },
    { name: "Asia/Baku", offset: 4, country: "Azerbaijan", countryCode: "AZ" },
    { name: "Asia/Tbilisi", offset: 4, country: "Georgia", countryCode: "GE" },
    { name: "Asia/Dubai", offset: 4, country: "United Arab Emirates", countryCode: "AE" },
    { name: "Asia/Muscat", offset: 4, country: "Oman", countryCode: "OM" },
    { name: "Indian/Mauritius", offset: 4, country: "Mauritius", countryCode: "MU" },
    { name: "Indian/Reunion", offset: 4, country: "Reunion", countryCode: "RE" },
    { name: "Europe/Samara", offset: 4, country: "Russia", countryCode: "RU" },
    { name: "Indian/Mahe", offset: 4, country: "Seychelles", countryCode: "SC" },
    { name: "Asia/Kabul", offset: 4.5, country: "Afghanistan", countryCode: "AF" },
    { name: "Indian/Kerguelen", offset: 5, country: "French Southern Territories", countryCode: "TF" },
    { name: "Indian/Maldives", offset: 5, country: "Maldives", countryCode: "MV" },
    { name: "Antarctica/Mawson", offset: 5, country: "Antarctica", countryCode: "AQ" },
    { name: "Asia/Karachi", offset: 5, country: "Pakistan", countryCode: "PK" },
    { name: "Asia/Dushanbe", offset: 5, country: "Tajikistan", countryCode: "TJ" },
    { name: "Asia/Ashgabat", offset: 5, country: "Turkmenistan", countryCode: "TM" },
    { name: "Asia/Tashkent", offset: 5, country: "Uzbekistan", countryCode: "UZ" },
    { name: "Asia/Qyzylorda", offset: 5, country: "Kazakhstan", countryCode: "KZ" },
    { name: "Asia/Yekaterinburg", offset: 5, country: "Russia", countryCode: "RU" },
    { name: "Asia/Colombo", offset: 5.5, country: "Sri Lanka", countryCode: "LK" },
    { name: "Asia/Kolkata", offset: 5.5, country: "India", countryCode: "IN" },
    { name: "Asia/Kathmandu", offset: 5.75, country: "Nepal", countryCode: "NP" },
    { name: "Asia/Dhaka", offset: 6, country: "Bangladesh", countryCode: "BD" },
    { name: "Asia/Thimphu", offset: 6, country: "Bhutan", countryCode: "BT" },
    { name: "Asia/Urumqi", offset: 6, country: "China", countryCode: "CN" },
    { name: "Asia/Almaty", offset: 6, country: "Kazakhstan", countryCode: "KZ" },
    { name: "Indian/Chagos", offset: 6, country: "British Indian Ocean Territory", countryCode: "IO" },
    { name: "Asia/Bishkek", offset: 6, country: "Kyrgyzstan", countryCode: "KG" },
    { name: "Asia/Omsk", offset: 6, country: "Russia", countryCode: "RU" },
    { name: "Antarctica/Vostok", offset: 6, country: "Antarctica", countryCode: "AQ" },
    { name: "Indian/Cocos", offset: 6.5, country: "Cocos Islands", countryCode: "CC" },
    { name: "Asia/Yangon", offset: 6.5, country: "Myanmar", countryCode: "MM" },
    { name: "Indian/Christmas", offset: 7, country: "Christmas Island", countryCode: "CX" },
    { name: "Antarctica/Davis", offset: 7, country: "Antarctica", countryCode: "AQ" },
    { name: "Asia/Hovd", offset: 7, country: "Mongolia", countryCode: "MN" },
    { name: "Asia/Bangkok", offset: 7, country: "Thailand", countryCode: "TH" },
    { name: "Asia/Ho_Chi_Minh", offset: 7, country: "Vietnam", countryCode: "VN" },
    { name: "Asia/Phnom_Penh", offset: 7, country: "Cambodia", countryCode: "KH" },
    { name: "Asia/Vientiane", offset: 7, country: "Laos", countryCode: "LA" },
    { name: "Asia/Novosibirsk", offset: 7, country: "Russia", countryCode: "RU" },
    { name: "Asia/Jakarta", offset: 7, country: "Indonesia", countryCode: "ID" },
    { name: "Australia/Perth", offset: 8, country: "Australia", countryCode: "AU" },
    { name: "Asia/Brunei", offset: 8, country: "Brunei", countryCode: "BN" },
    { name: "Asia/Makassar", offset: 8, country: "Indonesia", countryCode: "ID" },
    { name: "Asia/Macau", offset: 8, country: "Macao", countryCode: "MO" },
    { name: "Asia/Shanghai", offset: 8, country: "China", countryCode: "CN" },
    { name: "Asia/Hong_Kong", offset: 8, country: "Hong Kong", countryCode: "HK" },
    { name: "Asia/Irkutsk", offset: 8, country: "Russia", countryCode: "RU" },
    { name: "Asia/Kuala_Lumpur", offset: 8, country: "Malaysia", countryCode: "MY" },
    { name: "Asia/Manila", offset: 8, country: "Philippines", countryCode: "PH" },
    { name: "Asia/Singapore", offset: 8, country: "Singapore", countryCode: "SG" },
    { name: "Asia/Taipei", offset: 8, country: "Taiwan", countryCode: "TW" },
    { name: "Asia/Ulaanbaatar", offset: 8, country: "Mongolia", countryCode: "MN" },
    { name: "Australia/Eucla", offset: 8.75, country: "Australia", countryCode: "AU" },
    { name: "Asia/Dili", offset: 9, country: "Timor Leste", countryCode: "TL" },
    { name: "Asia/Jayapura", offset: 9, country: "Indonesia", countryCode: "ID" },
    { name: "Asia/Tokyo", offset: 9, country: "Japan", countryCode: "JP" },
    { name: "Asia/Pyongyang", offset: 9, country: "North Korea", countryCode: "KP" },
    { name: "Asia/Seoul", offset: 9, country: "South Korea", countryCode: "KR" },
    { name: "Pacific/Palau", offset: 9, country: "Palau", countryCode: "PW" },
    { name: "Asia/Chita", offset: 9, country: "Russia", countryCode: "RU" },
    { name: "Australia/Adelaide", offset: 9.5, country: "Australia", countryCode: "AU" },
    { name: "Australia/Darwin", offset: 9.5, country: "Australia", countryCode: "AU" },
    { name: "Australia/Brisbane", offset: 10, country: "Australia", countryCode: "AU" },
    { name: "Australia/Sydney", offset: 10, country: "Australia", countryCode: "AU" },
    { name: "Pacific/Guam", offset: 10, country: "Guam", countryCode: "GU" },
    { name: "Pacific/Saipan", offset: 10, country: "Northern Mariana Islands", countryCode: "MP" },
    { name: "Pacific/Chuuk", offset: 10, country: "Micronesia", countryCode: "FM" },
    { name: "Antarctica/DumontDUrville", offset: 10, country: "Antarctica", countryCode: "AQ" },
    { name: "Pacific/Port_Moresby", offset: 10, country: "Papua New Guinea", countryCode: "PG" },
    { name: "Asia/Vladivostok", offset: 10, country: "Russia", countryCode: "RU" },
    { name: "Australia/Lord_Howe", offset: 10.5, country: "Australia", countryCode: "AU" },
    { name: "Pacific/Bougainville", offset: 11, country: "Papua New Guinea", countryCode: "PG" },
    { name: "Antarctica/Casey", offset: 11, country: "Antarctica", countryCode: "AQ" },
    { name: "Pacific/Kosrae", offset: 11, country: "Micronesia", countryCode: "FM" },
    { name: "Pacific/Noumea", offset: 11, country: "New Caledonia", countryCode: "NC" },
    { name: "Pacific/Norfolk", offset: 11, country: "Norfolk Island", countryCode: "NF" },
    { name: "Asia/Sakhalin", offset: 11, country: "Russia", countryCode: "RU" },
    { name: "Pacific/Guadalcanal", offset: 11, country: "Solomon Islands", countryCode: "SB" },
    { name: "Pacific/Efate", offset: 11, country: "Vanuatu", countryCode: "VU" },
    { name: "Pacific/Fiji", offset: 12, country: "Fiji", countryCode: "FJ" },
    { name: "Pacific/Tarawa", offset: 12, country: "Kiribati", countryCode: "KI" },
    { name: "Pacific/Majuro", offset: 12, country: "Marshall Islands", countryCode: "MH" },
    { name: "Pacific/Nauru", offset: 12, country: "Nauru", countryCode: "NR" },
    { name: "Pacific/Auckland", offset: 12, country: "New Zealand", countryCode: "NZ" },
    { name: "Antarctica/McMurdo", offset: 12, country: "Antarctica", countryCode: "AQ" },
    { name: "Asia/Kamchatka", offset: 12, country: "Russia", countryCode: "RU" },
    { name: "Pacific/Funafuti", offset: 12, country: "Tuvalu", countryCode: "TV" },
    { name: "Pacific/Wake", offset: 12, country: "United States Minor Outlying Islands", countryCode: "UM" },
    { name: "Pacific/Wallis", offset: 12, country: "Wallis and Futuna", countryCode: "WF" },
    { name: "Pacific/Chatham", offset: 12.75, country: "New Zealand", countryCode: "NZ" },
    { name: "Pacific/Apia", offset: 13, country: "Samoa", countryCode: "WS" },
    { name: "Pacific/Kanton", offset: 13, country: "Kiribati", countryCode: "KI" },
    { name: "Pacific/Fakaofo", offset: 13, country: "Tokelau", countryCode: "TK" },
    { name: "Pacific/Tongatapu", offset: 13, country: "Tonga", countryCode: "TO" },
    { name: "Pacific/Kiritimati", offset: 14, country: "Kiribati", countryCode: "KI" },
];

export const timezoneObj = {
    NU: { name: "Pacific/Niue", offset: -11, country: "Niue", countryCode: "NU" },
    UM: { name: "Pacific/Wake", offset: 12, country: "United States Minor Outlying Islands", countryCode: "UM" },
    AS: { name: "Pacific/Pago_Pago", offset: -11, country: "American Samoa", countryCode: "AS" },
    CK: { name: "Pacific/Rarotonga", offset: -10, country: "Cook Islands", countryCode: "CK" },
    US: { name: "America/New_York", offset: -5, country: "United States", countryCode: "US" },
    PF: { name: "Pacific/Gambier", offset: -9, country: "French Polynesia", countryCode: "PF" },
    MX: { name: "America/Cancun", offset: -5, country: "Mexico", countryCode: "MX" },
    CA: { name: "America/St_Johns", offset: -3.5, country: "Canada", countryCode: "CA" },
    PN: { name: "Pacific/Pitcairn", offset: -8, country: "Pitcairn", countryCode: "PN" },
    BZ: { name: "America/Belize", offset: -6, country: "Belize", countryCode: "BZ" },
    GT: { name: "America/Guatemala", offset: -6, country: "Guatemala", countryCode: "GT" },
    NI: { name: "America/Managua", offset: -6, country: "Nicaragua", countryCode: "NI" },
    CR: { name: "America/Costa_Rica", offset: -6, country: "Costa Rica", countryCode: "CR" },
    SV: { name: "America/El_Salvador", offset: -6, country: "El Salvador", countryCode: "SV" },
    HN: { name: "America/Tegucigalpa", offset: -6, country: "Honduras", countryCode: "HN" },
    CL: { name: "America/Punta_Arenas", offset: -3, country: "Chile", countryCode: "CL" },
    EC: { name: "America/Guayaquil", offset: -5, country: "Ecuador", countryCode: "EC" },
    BR: { name: "America/Noronha", offset: -2, country: "Brazil", countryCode: "BR" },
    CO: { name: "America/Bogota", offset: -5, country: "Colombia", countryCode: "CO" },
    CU: { name: "America/Havana", offset: -5, country: "Cuba", countryCode: "CU" },
    TC: { name: "America/Grand_Turk", offset: -5, country: "Turks and Caicos Islands", countryCode: "TC" },
    KY: { name: "America/Cayman", offset: -5, country: "Cayman Islands", countryCode: "KY" },
    JM: { name: "America/Jamaica", offset: -5, country: "Jamaica", countryCode: "JM" },
    BS: { name: "America/Nassau", offset: -5, country: "Bahamas", countryCode: "BS" },
    PA: { name: "America/Panama", offset: -5, country: "Panama", countryCode: "PA" },
    HT: { name: "America/Port-au-Prince", offset: -5, country: "Haiti", countryCode: "HT" },
    PE: { name: "America/Lima", offset: -5, country: "Peru", countryCode: "PE" },
    KN: { name: "America/St_Kitts", offset: -4, country: "Saint Kitts and Nevis", countryCode: "KN" },
    MS: { name: "America/Montserrat", offset: -4, country: "Montserrat", countryCode: "MS" },
    BB: { name: "America/Barbados", offset: -4, country: "Barbados", countryCode: "BB" },
    LC: { name: "America/St_Lucia", offset: -4, country: "Saint Lucia", countryCode: "LC" },
    TT: { name: "America/Port_of_Spain", offset: -4, country: "Trinidad and Tobago", countryCode: "TT" },
    MQ: { name: "America/Martinique", offset: -4, country: "Martinique", countryCode: "MQ" },
    BL: { name: "America/St_Barthelemy", offset: -4, country: "Saint Barthelemy", countryCode: "BL" },
    BM: { name: "Atlantic/Bermuda", offset: -4, country: "Bermuda", countryCode: "BM" },
    VC: { name: "America/St_Vincent", offset: -4, country: "Saint Vincent and the Grenadines", countryCode: "VC" },
    BQ: { name: "America/Kralendijk", offset: -4, country: "Bonaire, Saint Eustatius and Saba ", countryCode: "BQ" },
    GP: { name: "America/Guadeloupe", offset: -4, country: "Guadeloupe", countryCode: "GP" },
    MF: { name: "America/Marigot", offset: -4, country: "Saint Martin", countryCode: "MF" },
    AW: { name: "America/Aruba", offset: -4, country: "Aruba", countryCode: "AW" },
    SX: { name: "America/Lower_Princes", offset: -4, country: "Sint Maarten", countryCode: "SX" },
    VG: { name: "America/Tortola", offset: -4, country: "British Virgin Islands", countryCode: "VG" },
    DM: { name: "America/Dominica", offset: -4, country: "Dominica", countryCode: "DM" },
    VI: { name: "America/St_Thomas", offset: -4, country: "U.S. Virgin Islands", countryCode: "VI" },
    GD: { name: "America/Grenada", offset: -4, country: "Grenada", countryCode: "GD" },
    AG: { name: "America/Antigua", offset: -4, country: "Antigua and Barbuda", countryCode: "AG" },
    PR: { name: "America/Puerto_Rico", offset: -4, country: "Puerto Rico", countryCode: "PR" },
    DO: { name: "America/Santo_Domingo", offset: -4, country: "Dominican Republic", countryCode: "DO" },
    AI: { name: "America/Anguilla", offset: -4, country: "Anguilla", countryCode: "AI" },
    GL: { name: "America/Danmarkshavn", offset: 0, country: "Greenland", countryCode: "GL" },
    CW: { name: "America/Curacao", offset: -4, country: "Curacao", countryCode: "CW" },
    BO: { name: "America/La_Paz", offset: -4, country: "Bolivia", countryCode: "BO" },
    GY: { name: "America/Guyana", offset: -4, country: "Guyana", countryCode: "GY" },
    PY: { name: "America/Asuncion", offset: -4, country: "Paraguay", countryCode: "PY" },
    VE: { name: "America/Caracas", offset: -4, country: "Venezuela", countryCode: "VE" },
    AR: { name: "America/Argentina/Buenos_Aires", offset: -3, country: "Argentina", countryCode: "AR" },
    AQ: { name: "Antarctica/McMurdo", offset: 12, country: "Antarctica", countryCode: "AQ" },
    FK: { name: "Atlantic/Stanley", offset: -3, country: "Falkland Islands", countryCode: "FK" },
    GF: { name: "America/Cayenne", offset: -3, country: "French Guiana", countryCode: "GF" },
    PM: { name: "America/Miquelon", offset: -3, country: "Saint Pierre and Miquelon", countryCode: "PM" },
    SR: { name: "America/Paramaribo", offset: -3, country: "Suriname", countryCode: "SR" },
    UY: { name: "America/Montevideo", offset: -3, country: "Uruguay", countryCode: "UY" },
    GS: { name: "Atlantic/South_Georgia", offset: -2, country: "South Georgia and the South Sandwich Islands", countryCode: "GS" },
    PT: { name: "Europe/Lisbon", offset: 0, country: "Portugal", countryCode: "PT" },
    CV: { name: "Atlantic/Cape_Verde", offset: -1, country: "Cabo Verde", countryCode: "CV" },
    CI: { name: "Africa/Abidjan", offset: 0, country: "Ivory Coast", countryCode: "CI" },
    GH: { name: "Africa/Accra", offset: 0, country: "Ghana", countryCode: "GH" },
    ML: { name: "Africa/Bamako", offset: 0, country: "Mali", countryCode: "ML" },
    GW: { name: "Africa/Bissau", offset: 0, country: "Guinea-Bissau", countryCode: "GW" },
    GN: { name: "Africa/Conakry", offset: 0, country: "Guinea", countryCode: "GN" },
    SN: { name: "Africa/Dakar", offset: 0, country: "Senegal", countryCode: "SN" },
    IM: { name: "Europe/Isle_of_Man", offset: 0, country: "Isle of Man", countryCode: "IM" },
    IE: { name: "Europe/Dublin", offset: 0, country: "Ireland", countryCode: "IE" },
    SL: { name: "Africa/Freetown", offset: 0, country: "Sierra Leone", countryCode: "SL" },
    SH: { name: "Atlantic/St_Helena", offset: 0, country: "Saint Helena", countryCode: "SH" },
    TG: { name: "Africa/Lome", offset: 0, country: "Togo", countryCode: "TG" },
    GB: { name: "Europe/London", offset: 0, country: "United Kingdom", countryCode: "GB" },
    LR: { name: "Africa/Monrovia", offset: 0, country: "Liberia", countryCode: "LR" },
    MR: { name: "Africa/Nouakchott", offset: 0, country: "Mauritania", countryCode: "MR" },
    BF: { name: "Africa/Ouagadougou", offset: 0, country: "Burkina Faso", countryCode: "BF" },
    IS: { name: "Atlantic/Reykjavik", offset: 0, country: "Iceland", countryCode: "IS" },
    JE: { name: "Europe/Jersey", offset: 0, country: "Jersey", countryCode: "JE" },
    GG: { name: "Europe/Guernsey", offset: 0, country: "Guernsey", countryCode: "GG" },
    GM: { name: "Africa/Banjul", offset: 0, country: "Gambia", countryCode: "GM" },
    ST: { name: "Africa/Sao_Tome", offset: 0, country: "Sao Tome and Principe", countryCode: "ST" },
    MA: { name: "Africa/Casablanca", offset: 0, country: "Morocco", countryCode: "MA" },
    EH: { name: "Africa/El_Aaiun", offset: 0, country: "Western Sahara", countryCode: "EH" },
    ES: { name: "Europe/Madrid", offset: 1, country: "Spain", countryCode: "ES" },
    FO: { name: "Atlantic/Faroe", offset: 0, country: "Faroe Islands", countryCode: "FO" },
    NA: { name: "Africa/Windhoek", offset: 1, country: "Namibia", countryCode: "NA" },
    DZ: { name: "Africa/Algiers", offset: 1, country: "Algeria", countryCode: "DZ" },
    NL: { name: "Europe/Amsterdam", offset: 1, country: "Netherlands", countryCode: "NL" },
    AD: { name: "Europe/Andorra", offset: 1, country: "Andorra", countryCode: "AD" },
    RS: { name: "Europe/Belgrade", offset: 1, country: "Serbia", countryCode: "RS" },
    DE: { name: "Europe/Berlin", offset: 1, country: "Germany", countryCode: "DE" },
    MT: { name: "Europe/Malta", offset: 1, country: "Malta", countryCode: "MT" },
    SK: { name: "Europe/Bratislava", offset: 1, country: "Slovakia", countryCode: "SK" },
    BE: { name: "Europe/Brussels", offset: 1, country: "Belgium", countryCode: "BE" },
    HU: { name: "Europe/Budapest", offset: 1, country: "Hungary", countryCode: "HU" },
    DK: { name: "Europe/Copenhagen", offset: 1, country: "Denmark", countryCode: "DK" },
    GI: { name: "Europe/Gibraltar", offset: 1, country: "Gibraltar", countryCode: "GI" },
    SI: { name: "Europe/Ljubljana", offset: 1, country: "Slovenia", countryCode: "SI" },
    SJ: { name: "Arctic/Longyearbyen", offset: 1, country: "Svalbard and Jan Mayen", countryCode: "SJ" },
    LU: { name: "Europe/Luxembourg", offset: 1, country: "Luxembourg", countryCode: "LU" },
    MC: { name: "Europe/Monaco", offset: 1, country: "Monaco", countryCode: "MC" },
    NO: { name: "Europe/Oslo", offset: 1, country: "Norway", countryCode: "NO" },
    FR: { name: "Europe/Paris", offset: 1, country: "France", countryCode: "FR" },
    ME: { name: "Europe/Podgorica", offset: 1, country: "Montenegro", countryCode: "ME" },
    CZ: { name: "Europe/Prague", offset: 1, country: "Czechia", countryCode: "CZ" },
    IT: { name: "Europe/Rome", offset: 1, country: "Italy", countryCode: "IT" },
    SM: { name: "Europe/San_Marino", offset: 1, country: "San Marino", countryCode: "SM" },
    BA: { name: "Europe/Sarajevo", offset: 1, country: "Bosnia and Herzegovina", countryCode: "BA" },
    MK: { name: "Europe/Skopje", offset: 1, country: "North Macedonia", countryCode: "MK" },
    SE: { name: "Europe/Stockholm", offset: 1, country: "Sweden", countryCode: "SE" },
    AL: { name: "Europe/Tirane", offset: 1, country: "Albania", countryCode: "AL" },
    TN: { name: "Africa/Tunis", offset: 1, country: "Tunisia", countryCode: "TN" },
    LI: { name: "Europe/Vaduz", offset: 1, country: "Liechtenstein", countryCode: "LI" },
    VA: { name: "Europe/Vatican", offset: 1, country: "Vatican", countryCode: "VA" },
    AT: { name: "Europe/Vienna", offset: 1, country: "Austria", countryCode: "AT" },
    PL: { name: "Europe/Warsaw", offset: 1, country: "Poland", countryCode: "PL" },
    HR: { name: "Europe/Zagreb", offset: 1, country: "Croatia", countryCode: "HR" },
    CH: { name: "Europe/Zurich", offset: 1, country: "Switzerland", countryCode: "CH" },
    CF: { name: "Africa/Bangui", offset: 1, country: "Central African Republic", countryCode: "CF" },
    GQ: { name: "Africa/Malabo", offset: 1, country: "Equatorial Guinea", countryCode: "GQ" },
    CG: { name: "Africa/Brazzaville", offset: 1, country: "Republic of the Congo", countryCode: "CG" },
    BJ: { name: "Africa/Porto-Novo", offset: 1, country: "Benin", countryCode: "BJ" },
    CM: { name: "Africa/Douala", offset: 1, country: "Cameroon", countryCode: "CM" },
    CD: { name: "Africa/Lubumbashi", offset: 2, country: "Democratic Republic of the Congo", countryCode: "CD" },
    NG: { name: "Africa/Lagos", offset: 1, country: "Nigeria", countryCode: "NG" },
    GA: { name: "Africa/Libreville", offset: 1, country: "Gabon", countryCode: "GA" },
    AO: { name: "Africa/Luanda", offset: 1, country: "Angola", countryCode: "AO" },
    TD: { name: "Africa/Ndjamena", offset: 1, country: "Chad", countryCode: "TD" },
    NE: { name: "Africa/Niamey", offset: 1, country: "Niger", countryCode: "NE" },
    BI: { name: "Africa/Bujumbura", offset: 2, country: "Burundi", countryCode: "BI" },
    BW: { name: "Africa/Gaborone", offset: 2, country: "Botswana", countryCode: "BW" },
    ZW: { name: "Africa/Harare", offset: 2, country: "Zimbabwe", countryCode: "ZW" },
    SS: { name: "Africa/Juba", offset: 2, country: "South Sudan", countryCode: "SS" },
    SD: { name: "Africa/Khartoum", offset: 2, country: "Sudan", countryCode: "SD" },
    RW: { name: "Africa/Kigali", offset: 2, country: "Rwanda", countryCode: "RW" },
    MW: { name: "Africa/Blantyre", offset: 2, country: "Malawi", countryCode: "MW" },
    ZM: { name: "Africa/Lusaka", offset: 2, country: "Zambia", countryCode: "ZM" },
    MZ: { name: "Africa/Maputo", offset: 2, country: "Mozambique", countryCode: "MZ" },
    SY: { name: "Asia/Damascus", offset: 2, country: "Syria", countryCode: "SY" },
    JO: { name: "Asia/Amman", offset: 2, country: "Jordan", countryCode: "JO" },
    GR: { name: "Europe/Athens", offset: 2, country: "Greece", countryCode: "GR" },
    LB: { name: "Asia/Beirut", offset: 2, country: "Lebanon", countryCode: "LB" },
    RO: { name: "Europe/Bucharest", offset: 2, country: "Romania", countryCode: "RO" },
    EG: { name: "Africa/Cairo", offset: 2, country: "Egypt", countryCode: "EG" },
    MD: { name: "Europe/Chisinau", offset: 2, country: "Moldova", countryCode: "MD" },
    PS: { name: "Asia/Hebron", offset: 2, country: "Palestinian Territory", countryCode: "PS" },
    FI: { name: "Europe/Helsinki", offset: 2, country: "Finland", countryCode: "FI" },
    RU: { name: "Asia/Kamchatka", offset: 12, country: "Russia", countryCode: "RU" },
    UA: { name: "Europe/Simferopol", offset: 3, country: "Ukraine", countryCode: "UA" },
    AX: { name: "Europe/Mariehamn", offset: 2, country: "Aland Islands", countryCode: "AX" },
    CY: { name: "Asia/Nicosia", offset: 2, country: "Cyprus", countryCode: "CY" },
    LV: { name: "Europe/Riga", offset: 2, country: "Latvia", countryCode: "LV" },
    BG: { name: "Europe/Sofia", offset: 2, country: "Bulgaria", countryCode: "BG" },
    EE: { name: "Europe/Tallinn", offset: 2, country: "Estonia", countryCode: "EE" },
    LY: { name: "Africa/Tripoli", offset: 2, country: "Libya", countryCode: "LY" },
    LT: { name: "Europe/Vilnius", offset: 2, country: "Lithuania", countryCode: "LT" },
    IL: { name: "Asia/Jerusalem", offset: 2, country: "Israel", countryCode: "IL" },
    ZA: { name: "Africa/Johannesburg", offset: 2, country: "South Africa", countryCode: "ZA" },
    SZ: { name: "Africa/Mbabane", offset: 2, country: "Eswatini", countryCode: "SZ" },
    LS: { name: "Africa/Maseru", offset: 2, country: "Lesotho", countryCode: "LS" },
    KW: { name: "Asia/Kuwait", offset: 3, country: "Kuwait", countryCode: "KW" },
    IQ: { name: "Asia/Baghdad", offset: 3, country: "Iraq", countryCode: "IQ" },
    QA: { name: "Asia/Qatar", offset: 3, country: "Qatar", countryCode: "QA" },
    BH: { name: "Asia/Bahrain", offset: 3, country: "Bahrain", countryCode: "BH" },
    SA: { name: "Asia/Riyadh", offset: 3, country: "Saudi Arabia", countryCode: "SA" },
    YE: { name: "Asia/Aden", offset: 3, country: "Yemen", countryCode: "YE" },
    ET: { name: "Africa/Addis_Ababa", offset: 3, country: "Ethiopia", countryCode: "ET" },
    MG: { name: "Indian/Antananarivo", offset: 3, country: "Madagascar", countryCode: "MG" },
    ER: { name: "Africa/Asmara", offset: 3, country: "Eritrea", countryCode: "ER" },
    TZ: { name: "Africa/Dar_es_Salaam", offset: 3, country: "Tanzania", countryCode: "TZ" },
    DJ: { name: "Africa/Djibouti", offset: 3, country: "Djibouti", countryCode: "DJ" },
    UG: { name: "Africa/Kampala", offset: 3, country: "Uganda", countryCode: "UG" },
    YT: { name: "Indian/Mayotte", offset: 3, country: "Mayotte", countryCode: "YT" },
    SO: { name: "Africa/Mogadishu", offset: 3, country: "Somalia", countryCode: "SO" },
    KM: { name: "Indian/Comoro", offset: 3, country: "Comoros", countryCode: "KM" },
    KE: { name: "Africa/Nairobi", offset: 3, country: "Kenya", countryCode: "KE" },
    BY: { name: "Europe/Minsk", offset: 3, country: "Belarus", countryCode: "BY" },
    TR: { name: "Europe/Istanbul", offset: 3, country: "Turkey", countryCode: "TR" },
    IR: { name: "Asia/Tehran", offset: 3.5, country: "Iran", countryCode: "IR" },
    AM: { name: "Asia/Yerevan", offset: 4, country: "Armenia", countryCode: "AM" },
    AZ: { name: "Asia/Baku", offset: 4, country: "Azerbaijan", countryCode: "AZ" },
    GE: { name: "Asia/Tbilisi", offset: 4, country: "Georgia", countryCode: "GE" },
    AE: { name: "Asia/Dubai", offset: 4, country: "United Arab Emirates", countryCode: "AE" },
    OM: { name: "Asia/Muscat", offset: 4, country: "Oman", countryCode: "OM" },
    MU: { name: "Indian/Mauritius", offset: 4, country: "Mauritius", countryCode: "MU" },
    RE: { name: "Indian/Reunion", offset: 4, country: "Reunion", countryCode: "RE" },
    SC: { name: "Indian/Mahe", offset: 4, country: "Seychelles", countryCode: "SC" },
    AF: { name: "Asia/Kabul", offset: 4.5, country: "Afghanistan", countryCode: "AF" },
    TF: { name: "Indian/Kerguelen", offset: 5, country: "French Southern Territories", countryCode: "TF" },
    MV: { name: "Indian/Maldives", offset: 5, country: "Maldives", countryCode: "MV" },
    PK: { name: "Asia/Karachi", offset: 5, country: "Pakistan", countryCode: "PK" },
    TJ: { name: "Asia/Dushanbe", offset: 5, country: "Tajikistan", countryCode: "TJ" },
    TM: { name: "Asia/Ashgabat", offset: 5, country: "Turkmenistan", countryCode: "TM" },
    UZ: { name: "Asia/Tashkent", offset: 5, country: "Uzbekistan", countryCode: "UZ" },
    KZ: { name: "Asia/Almaty", offset: 6, country: "Kazakhstan", countryCode: "KZ" },
    LK: { name: "Asia/Colombo", offset: 5.5, country: "Sri Lanka", countryCode: "LK" },
    IN: { name: "Asia/Kolkata", offset: 5.5, country: "India", countryCode: "IN" },
    NP: { name: "Asia/Kathmandu", offset: 5.75, country: "Nepal", countryCode: "NP" },
    BD: { name: "Asia/Dhaka", offset: 6, country: "Bangladesh", countryCode: "BD" },
    BT: { name: "Asia/Thimphu", offset: 6, country: "Bhutan", countryCode: "BT" },
    CN: { name: "Asia/Shanghai", offset: 8, country: "China", countryCode: "CN" },
    IO: { name: "Indian/Chagos", offset: 6, country: "British Indian Ocean Territory", countryCode: "IO" },
    KG: { name: "Asia/Bishkek", offset: 6, country: "Kyrgyzstan", countryCode: "KG" },
    CC: { name: "Indian/Cocos", offset: 6.5, country: "Cocos Islands", countryCode: "CC" },
    MM: { name: "Asia/Yangon", offset: 6.5, country: "Myanmar", countryCode: "MM" },
    CX: { name: "Indian/Christmas", offset: 7, country: "Christmas Island", countryCode: "CX" },
    MN: { name: "Asia/Ulaanbaatar", offset: 8, country: "Mongolia", countryCode: "MN" },
    TH: { name: "Asia/Bangkok", offset: 7, country: "Thailand", countryCode: "TH" },
    VN: { name: "Asia/Ho_Chi_Minh", offset: 7, country: "Vietnam", countryCode: "VN" },
    KH: { name: "Asia/Phnom_Penh", offset: 7, country: "Cambodia", countryCode: "KH" },
    LA: { name: "Asia/Vientiane", offset: 7, country: "Laos", countryCode: "LA" },
    ID: { name: "Asia/Jayapura", offset: 9, country: "Indonesia", countryCode: "ID" },
    AU: { name: "Australia/Lord_Howe", offset: 10.5, country: "Australia", countryCode: "AU" },
    BN: { name: "Asia/Brunei", offset: 8, country: "Brunei", countryCode: "BN" },
    MO: { name: "Asia/Macau", offset: 8, country: "Macao", countryCode: "MO" },
    HK: { name: "Asia/Hong_Kong", offset: 8, country: "Hong Kong", countryCode: "HK" },
    MY: { name: "Asia/Kuala_Lumpur", offset: 8, country: "Malaysia", countryCode: "MY" },
    PH: { name: "Asia/Manila", offset: 8, country: "Philippines", countryCode: "PH" },
    SG: { name: "Asia/Singapore", offset: 8, country: "Singapore", countryCode: "SG" },
    TW: { name: "Asia/Taipei", offset: 8, country: "Taiwan", countryCode: "TW" },
    TL: { name: "Asia/Dili", offset: 9, country: "Timor Leste", countryCode: "TL" },
    JP: { name: "Asia/Tokyo", offset: 9, country: "Japan", countryCode: "JP" },
    KP: { name: "Asia/Pyongyang", offset: 9, country: "North Korea", countryCode: "KP" },
    KR: { name: "Asia/Seoul", offset: 9, country: "South Korea", countryCode: "KR" },
    PW: { name: "Pacific/Palau", offset: 9, country: "Palau", countryCode: "PW" },
    GU: { name: "Pacific/Guam", offset: 10, country: "Guam", countryCode: "GU" },
    MP: { name: "Pacific/Saipan", offset: 10, country: "Northern Mariana Islands", countryCode: "MP" },
    FM: { name: "Pacific/Kosrae", offset: 11, country: "Micronesia", countryCode: "FM" },
    PG: { name: "Pacific/Bougainville", offset: 11, country: "Papua New Guinea", countryCode: "PG" },
    NC: { name: "Pacific/Noumea", offset: 11, country: "New Caledonia", countryCode: "NC" },
    NF: { name: "Pacific/Norfolk", offset: 11, country: "Norfolk Island", countryCode: "NF" },
    SB: { name: "Pacific/Guadalcanal", offset: 11, country: "Solomon Islands", countryCode: "SB" },
    VU: { name: "Pacific/Efate", offset: 11, country: "Vanuatu", countryCode: "VU" },
    FJ: { name: "Pacific/Fiji", offset: 12, country: "Fiji", countryCode: "FJ" },
    KI: { name: "Pacific/Kiritimati", offset: 14, country: "Kiribati", countryCode: "KI" },
    MH: { name: "Pacific/Majuro", offset: 12, country: "Marshall Islands", countryCode: "MH" },
    NR: { name: "Pacific/Nauru", offset: 12, country: "Nauru", countryCode: "NR" },
    NZ: { name: "Pacific/Chatham", offset: 12.75, country: "New Zealand", countryCode: "NZ" },
    TV: { name: "Pacific/Funafuti", offset: 12, country: "Tuvalu", countryCode: "TV" },
    WF: { name: "Pacific/Wallis", offset: 12, country: "Wallis and Futuna", countryCode: "WF" },
    WS: { name: "Pacific/Apia", offset: 13, country: "Samoa", countryCode: "WS" },
    TK: { name: "Pacific/Fakaofo", offset: 13, country: "Tokelau", countryCode: "TK" },
    TO: { name: "Pacific/Tongatapu", offset: 13, country: "Tonga", countryCode: "TO" },
};
